// import { parseExcelFile } from '@/api/dashboard/mockSpend/parser'

const toYearMonthNumber = (val: string) => {
  // Accepts "2023-1" or "2023-01" and returns 202301
  const [year, month] = val.split('-').map(Number)
  return year * 100 + month
}

const averageArray = (arr: any[], referenceArr: any[]) => {
  // Use referenceArr for keys if arr is empty
  const ref = arr.length > 0 ? arr : referenceArr
  if (!ref || ref.length === 0) return {}

  const keys = Object.keys(ref[0])
  const avgObj: any = {}

  keys.forEach((key) => {
    // If arr is empty, use '' for strings, 0 for numbers
    if (arr.length === 0) {
      avgObj[key] = typeof ref[0][key] === 'number' ? 0 : ''
    } else if (typeof ref[0][key] === 'number') {
      const sum = arr.reduce(
        (acc, obj) => acc + (typeof obj[key] === 'number' ? obj[key] : 0),
        0
      )
      avgObj[key] = Number((sum / arr.length).toFixed(2))
    } else {
      avgObj[key] = arr[0][key]
    }
  })

  return avgObj
}

export const mockDataHandler = async (
  branchName: string,
  startDate: string,
  endDate: string
) => {
  // Load spendMockData.json instead of parsing Excel
  const response = await fetch('/spendMockData.json')
  const parsed = await response.json()

  // Helper to filter an array by branchName and date, only if both keys are present
  const filterByBranchAndDate = (arr: any[]) =>
    arr.filter((row) => {
      const hasLocation = 'location' in row
      const hasDate = 'date' in row
      let branchMatch = true
      let inRange = true
      if (hasLocation) {
        branchMatch = branchName === 'All' ? true : row.location === branchName
      }
      if (hasDate) {
        const dateNum = toYearMonthNumber(row.date)
        const startNum = toYearMonthNumber(startDate)
        const endNum = toYearMonthNumber(endDate)
        inRange = dateNum >= startNum && dateNum <= endNum
      }
      // Only filter if both keys are present
      if (hasLocation && hasDate) {
        return branchMatch && inRange
      }
      // If either key is missing, do not filter out
      return true
    })

  return {
    locationList: parsed.locationList,
    suppliers: parsed.suppliers,
    mfrSpendRebate: filterByBranchAndDate(parsed.mfrSpendRebate),
    inventoryByLocation: [
      averageArray(
        filterByBranchAndDate(parsed.inventoryByLocation),
        parsed.inventoryByLocation
      ),
    ],
    cogsVsTheoretical:
      branchName === 'All'
        ? filterByBranchAndDate(parsed.cogsVsTheoretical)
        : [
            averageArray(
              filterByBranchAndDate(parsed.cogsVsTheoretical),
              parsed.cogsVsTheoretical
            ),
          ],
    ptiVsCpi: [
      averageArray(filterByBranchAndDate(parsed.ptiVsCpi), parsed.ptiVsCpi),
    ],
  }
}
